import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-municipalities',
  templateUrl: './municipalities.component.html',
  styleUrls: ['./municipalities.component.scss']
})
export class MunicipalitiesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
